module.exports = __webpack_public_path__ + "static/media/communication.9c900b0f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/communication.jpeg
// module id = 1029
// module chunks = 0